module.exports = __webpack_public_path__ + "img/2.68b5c9ac.jpg";